import { IPortalSection } from './types';

export const convertSection = ({
  ...data
}: IPortalSection<string>): IPortalSection<Date> => ({
  ...data,
  created_at: new Date(data.created_at),
  updated_at: new Date(data.updated_at),
});
